import React, { useEffect, useState } from "react"
import { Col, Row, Card, Button, Steps, List, Avatar } from "antd"
import { RouteComponentProps, useHistory } from "react-router-dom"
import SettingsPageSimple from "components-old/common/SettingsPage/SettingsPageSimple"
import InstagramSvg from "../svgs/InstagramSvg"
import { useStore } from "hooks"
import { envKeys } from "config/envs.config"
import { general } from "store"
import toast from "lib/toast"
import axios from "axios"
import { endpoints } from "config/endpoints.config"
import request from "lib/request"
import FacebookLogin from "@greatsumini/react-facebook-login"

function Step2(props: { accessToken: string }) {
  const history = useHistory()
  const [pages, setPages] = useState<any>([])
  const [loading, setLoading] = useState(-1)
  const [loadingAll, setLoadingAll] = useState(false)

  async function getPages() {
    setLoadingAll(true)
    axios({
      method: "get",
      url: endpoints.INSTAGRAM_GRAPH_API + props.accessToken,
    }).then((response) => {
      setLoadingAll(false)
      console.log(response)
      setPages(response.data)
    })
  }

  useEffect(() => {
    getPages()
  }, [])

  return (
    <List
      loading={loadingAll}
      itemLayout="horizontal"
      dataSource={pages?.data?.filter((page: any) => page.instagram_business_account?.id) || []}
      renderItem={(page: any) => (
        <Card style={{ width: "100%", marginBottom: 15 }} className="gray">
          <List.Item
            actions={[
              <Button
                type="primary"
                loading={loading == page.id}
                onClick={(e) => {
                  setLoading(page.id)
                  request
                    .save(endpoints.INSTAGRAM, {
                      avatar: page.picture.data.url,
                      pageInstagramId: page?.instagram_business_account?.id,
                      pageId: page?.id,
                      name: page.name,
                      accessToken: page.access_token,
                      groupIds: [],
                    })
                    .then((response) => {
                      toast.success(
                        <span>
                          Conectado ao canal de Instagram <strong>{response?.data.name}</strong>
                        </span>,
                      )
                      history.push("/settings/channels")
                    })
                    .finally(() => {
                      setLoading(-1)
                    })
                }}
              >
                Conectar
              </Button>,
            ]}
          >
            <List.Item.Meta
              avatar={<Avatar src={page?.picture?.data?.url} size="large" />}
              title={page.name}
              description={page.id}
              style={{ alignItems: "center" }}
            />
          </List.Item>
        </Card>
      )}
    />
  )
}
const getTextsByStep = (step: 0 | 1) => {
  switch (step) {
    case 0:
      return {
        centerTitle: "Add canal de Instagram",
        description: (
          <span>
            Vamos integrar sua página com o Kinbox. Para isso, clique no botão abaixo e selecione a página que você quer integrar no
            Instagram.
          </span>
        ),
      }
    case 1:
      return {
        centerTitle: "Conecte uma página...",
        description: <span>Selecione a página que você deseja conectar abaixo</span>,
      }
  }
}

function AddInstagram() {
  const [step, setStep] = useState<0 | 1>(0)
  const [data, setData] = useState<any>()
  const history = useHistory()
  const { _domain } = useStore(general)
  const appId = ((envKeys as any)[_domain.key] || {}).facebook_app_id || envKeys.staging.facebook_app_id

  const isStaging = _domain.key === "staging"

  // const configId = isStaging ? "933869491421356" : "3565994717047541";
  const configId = isStaging ? "386730984278187" : "808306644819434"

  return (
    <SettingsPageSimple
      backTo="/settings/channels/new"
      onBack={() => history.push("/settings/channels/new")}
      style={{
        width: 800,
      }}
      title={
        <Row align="middle">
          Canais {"> "}
          <Row align="middle">
            <span
              style={{
                width: 24,
                height: 24,
                display: "flex",
                marginRight: 10,
                marginLeft: 10,
              }}
            >
              <InstagramSvg />
            </span>
            Instagram
          </Row>
        </Row>
      }
      tabTitle="Canais > Instagram"
      centerTitle={
        <Row justify="center">
          <Col>{getTextsByStep(step)?.centerTitle}</Col>
        </Row>
      }
      description={
        <Row justify="center">
          <span style={{ maxWidth: 500 }}>{getTextsByStep(step)?.description}</span>
        </Row>
      }
      helpText={
        <span>Conecte-se aos aplicativos de mensagens mais usados pelos seus clientes e responda todos em sua caixa de entrada.</span>
      }
      center
    >
      <Row justify="center">
        <Steps current={step} style={{ maxWidth: 400 }}>
          <Steps.Step />
          <Steps.Step />
          <Steps.Step />
        </Steps>
      </Row>
      <br />
      <br />
      <br />
      {step == 0 && (
        <div>
          <Row justify="center">
            <FacebookLogin
              appId={appId}
              scope="instagram_basic, pages_show_list, instagram_manage_messages, pages_manage_metadata, pages_messaging, business_management"
              initParams={
                {
                  version: "v19.0",
                } as any
              }
              language="pt_BR"
              onSuccess={(response) => {
                setData(response)
                setStep(1)
                console.log("Login Success!", response)
              }}
              onFail={(error) => {
                console.log("Login Failed!", error)
              }}
              onProfileSuccess={(response) => {
                console.log("Get Profile Success!", response)
              }}
              loginOptions={
                {
                  config_id: configId,
                  // response_type: "code",
                  // override_default_response_type: true,
                } as any
              }
              render={({ onClick }) => (
                <Button icon={<i className="fab fa-instagram" />} size="large" onClick={onClick} type="primary">
                  Conectar página do Instagram
                </Button>
              )}
            />
          </Row>
        </div>
      )}
      {step == 1 && <Step2 accessToken={data?.accessToken} />}
      <br />
    </SettingsPageSimple>
  )
}

export default AddInstagram
